import Vue from 'vue';
import firebase from '@/services/firebaseConfig';
import 'firebase/auth';

export default new Vue({
  data: {
    user: null,
  },
  methods: {
    initialize() {

    },
  },
  beforeCreate() {
    firebase.auth().onAuthStateChanged((user) => {
      this.user = user;
      this.$emit('authChange', user);
    });
  },
});
